import React, { Component } from "react";

export default class BaseForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      password: null,
      loading: false,
      error: null
    };

    this.inputChanged = this.inputChanged.bind(this);
    this.handleForm = this.handleForm.bind(this);
  }

  inputChanged(e) {
    const name = e.target.name;
    this.setState({ [name]: e.target.value });
  }

  togglePasswordVisibility() {
      let passwordEl = document.querySelector('input[name="password"]');
      if ( passwordEl.getAttribute('type') === 'password' ) {
          passwordEl.setAttribute('type', 'text')
      } else {
          passwordEl.setAttribute('type', 'password')
      }
  }

  async handleForm() {}
  render() {
    return (
      <div className="login">
        <h2>BaseForm</h2>
        {this.state.error && (
          <div className="error">
            <p>{this.state.error}</p>
          </div>
        )}
        <input
          name="email"
          type="email"
          placeholder="Email"
          onChange={this.inputChanged}
        />
          test
        <input
          name="password"
          type="password"
          placeholder="Mot de passe"
          onChange={this.inputChanged}
        />
        <button onClick={this.handleLogin}>Me connecter</button>
      </div>
    );
  }
}
